(function(){
    async function fetchJson(url){
      try{
        const base = (window && window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
        const full = url.startsWith('http') ? url : (url.startsWith('/') ? url : (base.replace(/\/$/, '/') + url));
        const res = await fetch(full, { credentials: 'same-origin' });
        if (!res) return null;
        if (!res.ok) return null;
        const ct = (res.headers.get('content-type') || '').toLowerCase();
        if (!ct.includes('application/json')) return null;
        return await res.json();
      }catch(e){ return null; }
    }
    async function fetchProductExactByProductId(productId){
      const base = (window && window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
      const idsParam = encodeURIComponent(String(productId));
      const url = (base.replace(/\/$/, '/') + 'products.json?ids=' + idsParam);
      const res = await fetch(url, { credentials: 'same-origin' }).then(r => r.ok ? r.json() : null);
      if (!res || !res.products || !Array.isArray(res.products)) return null;
      const exact = res.products.find(p => String(p.id) === String(productId));
      return exact || null;
    }
    async function getFullProductByHandle(handle){
      if (!handle) return null;
      try {
        const base = (window && window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
        const url = base.replace(/\/$/, '/') + 'products/' + encodeURIComponent(String(handle)) + '.js';
        const product = await fetch(url, { credentials: 'same-origin' }).then(r => r.ok ? r.json() : null);
        return product;
      } catch(e) {
        console.error('[SELLING_PLAN] Error fetching full product by handle:', e);
        return null;
      }
    }
    async function fetchProductByIdOrVariantAttrs({ productId, variantId }){
      // Prefer productId to avoid extra variant lookup and locale path issues
      if (productId) {
        const prod = await fetchProductExactByProductId(productId);
        if (prod) return prod;
      }
      if (variantId) {
        const v = await fetchJson('/variants/' + encodeURIComponent(String(variantId)) + '.json');
        const pid = (v && v.variant && typeof v.variant.product_id !== 'undefined') ? v.variant.product_id : null;
        if (pid) {
          const prod = await fetchProductExactByProductId(pid);
          if (prod) return prod;
        }
      }
      return null;
    }
    function mapProductToImages(product){
      if (!product) return [];
      const images = Array.isArray(product.images) ? product.images : [];
      let list = images.slice();
      const featuredId = product.image_id || (product.image && product.image.id) || null;
      if (featuredId){
        list.sort((a,b)=> (a.id===featuredId? -1 : b.id===featuredId? 1 : 0));
      }
      const withWidth = (src, size) => {
        const sep = src.includes('?') ? '&' : '?';
        return `${src}${sep}width=${size}`;
      };
      return list.map(img => ({
        alt: img.alt || '',
        width: img.width || '',
        height: img.height || '',
        src_360: withWidth(img.src, 360),
        src_640: withWidth(img.src, 640),
        src_750: withWidth(img.src, 750),
        src_828: withWidth(img.src, 828),
        src_1080: withWidth(img.src, 1080),
        src_1280: withWidth(img.src, 1280)
      }));
    }
    function buildSlidesHtml(images){
      const main = images.map((img, idx) => (
        `<div class="shopify-slider-slide iytPxehuLgUqoxXQ6" data-shopify-type="slider-slide" layerId="ytPxehuLgUqoxXQ6">\n        <div data-shopify-type="image" class="ivkJ7tiDLPBwLMk8t"><img alt="${img.alt || ''}" sizes="(max-width: 1280px) 100vw, 1280px" srcset="${img.src_360} 360w, ${img.src_640} 640w, ${img.src_750} 750w, ${img.src_828} 828w, ${img.src_1080} 1080w, ${img.src_1280} 1280w" src="${img.src_1280}" width="${img.width || ''}" height="${img.height || ''}" decoding="async" loading="${idx===0?'eager':'lazy'}" fetchpriority="${idx===0?'high':'auto'}" class="shopify-image shopify-image__main"></div>\n      </div>`)).join('');
      const thumbs = images.map((img, idx) => (
        `<div class="shopify-slider-slide iA7jBRXnSUIAbCr1c" data-shopify-type="slider-slide" layerId="A7jBRXnSUIAbCr1c">
            <div data-shopify-type="image" class="i9P5R4TQc9YakHTAG"><img alt="${img.alt || ''}" sizes="(max-width: 640px) 100vw, 640px" srcset="${img.src_360} 360w, ${img.src_640} 640w" src="${img.src_640}" width="${img.width || ''}" height="${img.height || ''}" decoding="async" loading="${idx===0?'eager':'lazy'}" fetchpriority="${idx===0?'high':'auto'}" class="shopify-image shopify-image__main"></div>
          </div>`)).join('');
      return { main, thumbs };
    }
    function destroyIfSwiper(el){
      try{ if (window.Swiper && el && el.swiper) { el.swiper.destroy(true,true); } }catch(e){}
    }
    function refreshSliders(){
      try{ if (window.__shopifyInitSliders) window.__shopifyInitSliders(); }catch(e){}
      try{ window.dispatchEvent(new Event('resize')); }catch(e){}
    }
    function initSection(root){
      if (!root) return;
      // Guard against double-initialization on the same root (e.g., section:load + bootAll)
      if (root.__perlaProductFlavoursInit) return;
      Object.defineProperty(root, '__perlaProductFlavoursInit', { value: true, enumerable: false, configurable: false });
      // Per-section inline data
      let PRICE_MAP = null;
      try{
        const el = root.querySelector('script[id^="perla-price-map"]');
        if (el) { PRICE_MAP = JSON.parse(el.textContent || '{}'); }
      }catch(e){ PRICE_MAP = null; }
      let CURRENCY_INFO = null;
      try{
        const ce = root.querySelector('script[id^="perla-currency"]');
        if (ce) { CURRENCY_INFO = JSON.parse(ce.textContent || '{}'); }
      }catch(e){ CURRENCY_INFO = null; }
      
      // Store variant data at section level so it's accessible to event handlers
      let currentVariantData = {};
      let currentOneTimeVariant = null;
      let currentProduct = null;
  
      function ensureSymbolPrefix(formatted) {
        if (!formatted) return '';
        if (!CURRENCY_INFO || !CURRENCY_INFO.symbol) return String(formatted);
        const sym = String(CURRENCY_INFO.symbol);
        // console.log("sym", sym)
        const code = String(CURRENCY_INFO.code || '');
        //  console.log("code", code)
        let s = String(formatted);
        // console.log("s", s)
        // Remove provided currency code if present (case-insensitive, with word boundaries)
        if (code) {
          try { s = s.replace(new RegExp('\\b'+code+'\\b','gi'), ''); } catch(e) { s = s.split(code).join(''); }
        }
        // Also defensively remove any trailing 3-letter currency codes (e.g., EUR, USD, PLN)
        try { s = s.replace(/\b[A-Za-z]{3}\b/g, ''); } catch(e) {}
        s = s.split(sym).join('');
        s = s.trim();
        s = s.replace(/\s{2,}/g,' ');
        return `${sym}${s}`;
      }
      function swapCarousel(images){
        const main = root.querySelector('[data-shopify-type="slider"]');
        const thumbs = root.querySelector('[data-shopify-type="thumbnails"]');
        if(!main || !thumbs) return;
        destroyIfSwiper(main); destroyIfSwiper(thumbs);
        const mainWrapper = main.querySelector('.shopify-slider-wrapper');
        const thumbsWrapper = thumbs.querySelector('.shopify-slider-wrapper');
        if(!mainWrapper || !thumbsWrapper) return;
        const html = buildSlidesHtml(images);
        mainWrapper.innerHTML = html.main; thumbsWrapper.innerHTML = html.thumbs;
        refreshSliders();
      }
      // function formatMoneyCents(value){
  
      //   let centsInt;
      //   if (typeof value === 'string') {
      //     // console.log("value", parseFloat(value))
      //     if (value.indexOf('.') !== -1) {
      //       centsInt = Math.round(parseFloat(value) * 100);
      //     } else {
      //       centsInt = parseInt(value, 10);
      //     }
      //   } else if (typeof value === 'number') {
      //     centsInt = value < 1000 ? Math.round(value * 100) : Math.round(value);
        
      //   } else {
      //     return '';
      //   }
      //   try {
      //     const cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ? window.Shopify.currency.active : undefined;
      //     return (centsInt/100).toLocaleString(undefined, { style: cur? 'currency' : 'currency', currency: cur || 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 });
      //   } catch(e) {
      //     return '€' + (centsInt/100).toFixed(0);
      //   }
      // }
      function formatMoneyCents(value){
  // console.log("value", value)
        let centsInt;
        if (typeof value === 'string') {
          if (value.indexOf('.') !== -1) {
            centsInt = Math.round(parseFloat(value));
            // console.log("centsInt", centsInt)
          } else {
            centsInt = parseInt(value, 10);
          }
        } else if (typeof value === 'number') {
          centsInt = value < 1000 ? Math.round(value) : Math.round(value);
        
        } else {
          return '';
        }
        return centsInt;
      }
  
      // Parse price-like values (numbers or strings with currency symbols) to a numeric amount
      function parseAmountToNumber(value){
        if (typeof value === 'number') {
          // If value is an integer > 10 and < 1000000, it's likely in cents (Shopify format), divide by 100
          if (Number.isInteger(value) && value > 10 && value < 1000000) {
            return value / 100;
          }
          return value;
        }
        if (typeof value === 'string') {
          try {
            let s = value.replace(/\s+/g, ' ').trim();
            s = s.replace(/\u00A0/g, ' '); // nbsp
            s = s.replace(/\b[A-Za-z]{3}\b/g, ''); // remove currency codes like EUR, USD
            s = s.replace(/[€$£₹₽₴₺¥₩₪₫₦₱₡₭฿₲₵₸₮]/g, '');
            s = s.replace(/,/g, '.'); // treat comma as decimal separator
            s = s.replace(/[^0-9.]/g, '');
            // Keep only the first dot as decimal separator
            const firstDot = s.indexOf('.');
            if (firstDot !== -1) {
              const left = s.slice(0, firstDot + 1);
              const right = s.slice(firstDot + 1).replace(/\./g, '');
              s = left + right;
            }
            const n = parseFloat(s);
            if (!isNaN(n)) return n;
          } catch(e){}
        }
        // Fallback to numeric rounding if possible
        const fallback = formatMoneyCents(value);
        const n = typeof fallback === 'number' ? fallback : parseFloat(String(fallback || ''));
        return isNaN(n) ? 0 : n;
      }
  
      // Format numeric amount to string with max 2 decimals, no trailing zeros
      function formatAmountString(amount){
        const n = parseFloat(String(amount));
        if (!isFinite(n)) return '';
        const rounded = Math.round(n * 100) / 100;
        let s = rounded.toFixed(2);
        s = s.replace(/\.00$/, '');
        s = s.replace(/(\.\d)0$/, '$1');
        return s;
      }
  
      // Format any value (number or currency string) to display with currency symbol and max 2 decimals
      function formatDisplayPrice(value, qtyMultiplier){
        const qty = Math.max(1, Number(qtyMultiplier || 1));
        const base = parseAmountToNumber(value);
        const computed = base * qty;
        const amountStr = formatAmountString(computed);
        const sym = (CURRENCY_INFO && CURRENCY_INFO.symbol) ? String(CURRENCY_INFO.symbol) : '';
        return sym ? (sym + amountStr) : amountStr;
      }
  
      // Parse price-like values (numbers or strings with currency symbols) to a float amount
      function parseAmountToNumber(value){
        if (typeof value === 'number') {
          return value;
        }
        if (typeof value === 'string') {
          try {
            // Normalize: remove currency codes/symbols, convert comma decimals to dot
            let s = value.replace(/\s+/g, ' ').trim();
            s = s.replace(/\u00A0/g, ' '); // nbsp
            s = s.replace(/\b[A-Za-z]{3}\b/g, ''); // remove currency codes like EUR, USD
            s = s.replace(/[€$£₹₽₴₺¥₩₪₫₦₱₡₭฿₲₵₸₮]/g, '');
            s = s.replace(/,/g, '.'); // treat comma as decimal separator
            s = s.replace(/[^0-9.]/g, '');
            // Keep only the first dot as decimal separator
            const firstDot = s.indexOf('.');
            if (firstDot !== -1) {
              const left = s.slice(0, firstDot + 1);
              const right = s.slice(firstDot + 1).replace(/\./g, '');
              s = left + right;
            }
            const n = parseFloat(s);
            if (!isNaN(n)) return n;
          } catch(e){}
        }
        // Fallback to numeric rounding if possible
        const fallback = formatMoneyCents(value);
        const n = typeof fallback === 'number' ? fallback : parseFloat(String(fallback || ''));
        return isNaN(n) ? 0 : n;
      }

      // Get promo code from HTML (set via Shopify schema)
      function getPromoCode() {
        const promoCodeSpan = root.querySelector('.product-block-promo-code');
        if (promoCodeSpan) {
          // Prefer data-attribute, fallback to text content (excluding button text)
          const code = promoCodeSpan.getAttribute('data-promo-code');
          if (code) return code.trim();
          // If no data-attribute, get text content but exclude button text
          const clone = promoCodeSpan.cloneNode(true);
          const button = clone.querySelector('.product-block-promo-copy-btn');
          if (button) button.remove();
          const textCode = clone.textContent.trim();
          return textCode || null;
        }
        return null;
      }

      // Get promo discount percentage from HTML
      function getPromoDiscountPercentage() {
        const promoBlock = root.querySelector('.product-block-promo');
        if (promoBlock) {
          const discount = promoBlock.getAttribute('data-promo-discount');
          if (discount) {
            const num = parseFloat(discount);
            if (!isNaN(num) && num > 0 && num <= 100) {
              return num;
            }
          }
        }
        return null;
      }

      // Copy promo code to clipboard
      async function copyPromoCode() {
        const promoCode = getPromoCode();
        if (!promoCode) return false;
        
        try {
          // Use modern Clipboard API if available
          if (navigator.clipboard && navigator.clipboard.writeText) {
            await navigator.clipboard.writeText(promoCode);
            return true;
          } else {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = promoCode;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try {
              const successful = document.execCommand('copy');
              document.body.removeChild(textArea);
              return successful;
            } catch (err) {
              document.body.removeChild(textArea);
              return false;
            }
          }
        } catch (err) {
          console.warn('[PROMO] Failed to copy promo code:', err);
          return false;
        }
      }

      // Wire promo code copy button
      function wirePromoCopyButton() {
        const copyBtn = root.querySelector('.product-block-promo-copy-btn');
        if (!copyBtn) return;
        
        // Prevent double-binding
        if (copyBtn.__perlaCopyBound) return;
        copyBtn.__perlaCopyBound = true;
        
        copyBtn.addEventListener('click', async function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const success = await copyPromoCode();
          
          if (success) {
            // Visual feedback - change button appearance temporarily
            const originalHTML = copyBtn.innerHTML;
            copyBtn.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3333 4L6 11.3333L2.66667 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            copyBtn.setAttribute('aria-label', 'Copied!');
            copyBtn.setAttribute('title', 'Copied!');
            copyBtn.style.color = '#4CAF50';
            
            // Reset after 2 seconds
            setTimeout(() => {
              copyBtn.innerHTML = originalHTML;
              copyBtn.setAttribute('aria-label', 'Copy promo code');
              copyBtn.setAttribute('title', 'Copy promo code');
              copyBtn.style.color = '';
            }, 2000);
          }
        });
      }

      // Update promo code and discounted price
      function updatePromoDisplay(selectedVariant) {
        const promoBlock = root.querySelector('.product-block-promo');
        if (!promoBlock) return;
        
        const promoCodeSpan = promoBlock.querySelector('.product-block-promo-code');
        const promoPriceSpan = promoBlock.querySelector('.product-block-promo-price');
        
        // Promo code is already set in HTML via Liquid, no need to update it
        
        // Check if one-time is selected - don't update promo price, keep previous value
        const oneTimeBlock = root.querySelector('.product-block-one-time');
        const isOneTimeSelected = oneTimeBlock && oneTimeBlock.classList.contains('selected');
        
        if (isOneTimeSelected) {
          // Don't update promo price for one-time variant, keep it as it was
          return;
        }
        
        // Calculate and display discounted price only for subscribe variants
        if (selectedVariant && promoPriceSpan) {
          try {
            // Determine quantity multiplier based on selected plan
            let qtyMultiplier = 1;
            // For subscribe plans, get multiplier from data-subscribe attribute
            const subscribeVariant = root.querySelector('.product-block-subscribe-variant.selected') || root.querySelector('.product-block-subscribe-variant:not(.product-block-subscribe-variant-template)');
            if (subscribeVariant) {
              const subscribePlan = subscribeVariant.getAttribute('data-subscribe') || '';
              const match = subscribePlan.match(/(\d+)/);
              if (match && match[1]) {
                const parsed = parseInt(match[1], 10);
                if (!isNaN(parsed) && parsed > 0) {
                  qtyMultiplier = parsed;
                }
              }
            }
            
            // Get variant price - try to get product_id from variant or find it in PRICE_MAP
            let productId = selectedVariant.product_id;
            if (!productId && PRICE_MAP) {
              // Try to find product_id by searching through PRICE_MAP
              for (const pid in PRICE_MAP) {
                if (PRICE_MAP[pid].variants && PRICE_MAP[pid].variants[String(selectedVariant.id)]) {
                  productId = pid;
                  break;
                }
              }
            }
            
            const pmap = PRICE_MAP && productId && PRICE_MAP[String(productId)] && PRICE_MAP[String(productId)].variants ? PRICE_MAP[String(productId)].variants : null;
            const vMap = pmap ? pmap[String(selectedVariant.id)] : null;
            
            let priceValue = vMap && typeof vMap.price !== 'undefined' && vMap.price !== null ? vMap.price : selectedVariant.price;
            
            // Convert from cents if needed
            if (typeof priceValue === 'number' && Number.isInteger(priceValue) && priceValue > 10 && priceValue < 1000000) {
              priceValue = priceValue / 100;
            } else if (typeof priceValue === 'string') {
              priceValue = parseAmountToNumber(priceValue);
            }
            
            // Apply quantity multiplier to base price
            const totalPriceValue = priceValue * qtyMultiplier;
            
            // Get discount percentage from HTML
            const discountPercentage = getPromoDiscountPercentage();
            
            if (discountPercentage !== null) {
              // Calculate discounted price (apply discount to total price with quantity)
              const discountedPrice = totalPriceValue * (1 - discountPercentage / 100);
              const roundedDiscountedPrice = Math.round(discountedPrice);
              const formattedPrice = formatDisplayPrice(roundedDiscountedPrice, 1);
              promoPriceSpan.textContent = formattedPrice;
            } else {
              // Fallback: show original price if discount percentage is not available
              const roundedTotalPriceValue = Math.round(totalPriceValue);
              promoPriceSpan.textContent = formatDisplayPrice(roundedTotalPriceValue, 1);
            }
          } catch(e) {
            console.warn('[PROMO] Failed to calculate discounted price:', e);
          }
        }
      }
  
  
  
  
      function splitVariants(product){
        const variants = Array.isArray(product && product.variants) ? product.variants : [];
        const oneTime = variants.find(v => /one[- ]?time/i.test(v.title || '')) || null;
        const subs = variants.filter(v => !/one[- ]?time/i.test(v.title || ''));
        return { oneTime, subs };
      }
  
      // --- Mixed Flavour visibility control ---
      function initMixedFlavourVisibility() {
        const mf = root.querySelector('.product-block-flavour-mf');
        if (mf) {
          try { mf.style.display = 'none'; } catch(e) {}
        }
      }
      function updateMixedFlavourVisibilityForVariant(selectedVariantEl) {
        const mf = root.querySelector('.product-block-flavour-mf');
        if (!mf) return;
        const isMfActive = mf && mf.classList && mf.classList.contains('active');
        if (isMfActive) { try { mf.style.display = ''; } catch(e) {} return; }
        if (!selectedVariantEl) return;
        // Check if selected plan is 3-month (prioritize data-subscribe attribute)
        let currentPlan = selectedVariantEl.getAttribute('data-subscribe') || '';
        // If data-subscribe is not set or is empty, try to get from selectNative
        if (!currentPlan) {
          const selectWrapper = selectedVariantEl.querySelector('.product-block-subscribe-select-wrapper');
          const selectNative = selectWrapper ? selectWrapper.querySelector('.product-block-subscribe-select-native') : null;
          if (selectNative && selectNative.value) {
            currentPlan = selectNative.value;
          }
        }
        // Only show Mixed Flavours if current plan is exactly '3-month'
        const isThirdVariant = currentPlan === '3-month';
        try { mf.style.display = isThirdVariant ? '' : 'none'; } catch(e) {}
      }
  
      function populateSubscriptions(product){
        // Store current product at section level
        currentProduct = product;
        const { oneTime, subs } = splitVariants(product);
        // Store one-time variant at section level
        if (oneTime) {
          currentOneTimeVariant = { ...oneTime };
          if (!currentOneTimeVariant.product_id && product && product.id) {
            currentOneTimeVariant.product_id = product.id;
          }
        } else {
          currentOneTimeVariant = null;
        }
        const container = root.querySelector('.product-block-subscribe-variants');
        if (!container) return;
        const mainItem = container.querySelector('.product-block-subscribe-variant:not(.product-block-subscribe-variant-template)');
        const templates = Array.from(container.querySelectorAll('.product-block-subscribe-variant-template'));
        const selectWrapper = mainItem ? mainItem.querySelector('.product-block-subscribe-select-wrapper') : null;
        const selectButton = selectWrapper ? selectWrapper.querySelector('.product-block-subscribe-select') : null;
        const selectDropdown = selectWrapper ? selectWrapper.querySelector('.product-block-subscribe-select-dropdown') : null;
        const selectNative = selectWrapper ? selectWrapper.querySelector('.product-block-subscribe-select-native') : null;
        if (!mainItem || !selectWrapper || !selectButton || !selectDropdown) return;
        
        const mfButton = root.querySelector('.product-block-flavour-mf');
        const mfActive = !!(mfButton && mfButton.classList && mfButton.classList.contains('active'));
        const isMfSingle = mfActive && Array.isArray(subs) && subs.length === 1;
        
        // Map variants to plans: 0=1-month, 1=2-month, 2=3-month
        const planMap = ['1-month', '2-month', '3-month'];
        // Update current variant data at section level
        currentVariantData = {};
        
        planMap.forEach((planKey, idx) => {
          const mappedIdx = isMfSingle ? (idx === 2 ? 0 : -1) : idx;
          const v = (mappedIdx === -1) ? null : subs[mappedIdx];
          if (v) {
            currentVariantData[planKey] = {
              variant: v,
              index: mappedIdx
            };
          }
        });
        
        // Function to update main item content from template or variant data
        function updateMainItemContent(planKey) {
          const template = templates.find(t => t.getAttribute('data-subscribe') === planKey);
          const variantInfo = currentVariantData[planKey];
          
          if (!variantInfo) return;
          
          const v = variantInfo.variant;
          
          // Update data attributes
          mainItem.dataset.variantId = String(v.id);
          mainItem.setAttribute('data-subscribe', planKey);
          
          // Extract and add selling_plan
          let sellingPlanId = null;
          if (v.selling_plan_allocations && Array.isArray(v.selling_plan_allocations) && v.selling_plan_allocations.length > 0) {
            const allocation = v.selling_plan_allocations[0];
            if (allocation && allocation.selling_plan_id) {
              sellingPlanId = allocation.selling_plan_id;
            }
          }
          if (sellingPlanId) {
            mainItem.dataset.sellingPlan = String(sellingPlanId);
          } else {
            mainItem.removeAttribute('data-selling-plan');
          }
          
          // Update per-serving and save text from template (if template exists)
          // Prices are updated dynamically below
          if (template) {
            const templateBlock = template.querySelector('.product-block-subscribe-variant-block');
            if (templateBlock) {
              // Update per-serving text
              const templatePerServing = templateBlock.querySelector('.product-block-subscribe-per-serving');
              const mainPerServing = mainItem.querySelector('.product-block-subscribe-per-serving');
              if (templatePerServing && mainPerServing) {
                mainPerServing.innerHTML = templatePerServing.innerHTML;
              }
              
              // Update save text - only update p element, preserve img
              const templateSaveText = templateBlock.querySelector('.product-block-subscribe-left-save');
              const mainSaveText = mainItem.querySelector('.product-block-subscribe-left-save');
              if (templateSaveText && mainSaveText) {
                const templateP = templateSaveText.querySelector('p');
                const mainP = mainSaveText.querySelector('p');
                if (templateP && mainP) {
                  mainP.innerHTML = templateP.innerHTML;
                }
              }
            }
            
            // Update delivered text - preserve img, update only text content
            const templateContent = template.querySelector('.product-block-subscribe-variant-content');
            if (templateContent) {
              const templateDelivered = templateContent.querySelector('.product-block-delivered');
              const mainDelivered = mainItem.querySelector('.product-block-delivered');
              if (templateDelivered && mainDelivered) {
                // Get text content from template (excluding img)
                const templateClone = templateDelivered.cloneNode(true);
                const templateImg = templateClone.querySelector('img');
                if (templateImg) {
                  templateImg.remove();
                }
                const templateText = templateClone.textContent.trim();
                
                // Update main delivered - preserve img, update text
                const mainImg = mainDelivered.querySelector('img');
                if (mainImg) {
                  // Remove all text nodes, keep only img
                  const textNodes = [];
                  for (let node of mainDelivered.childNodes) {
                    if (node.nodeType === Node.TEXT_NODE) {
                      textNodes.push(node);
                    }
                  }
                  textNodes.forEach(node => node.remove());
                  
                  // Add text after img
                  const textNode = document.createTextNode(' ' + templateText);
                  mainDelivered.appendChild(textNode);
                } else {
                  // If no img, just update innerHTML
                  mainDelivered.innerHTML = templateDelivered.innerHTML;
                }
              }
            }
          }
          
          // Note: per-serving and save-text are usually static from templates,
          // but we ensure they're updated if needed. Content is updated from template above.
          
          // Determine quantity multiplier
          let qtyMultiplier = 1;
          if (!mfActive) {
            try {
              const m = planKey.match(/(\d+)/);
              if (m && m[1]) {
                const q = parseInt(m[1], 10);
                if (!isNaN(q) && q > 0) qtyMultiplier = q;
              }
            } catch(e){ qtyMultiplier = 1; }
          }
          
          // Update prices dynamically (get fresh references AFTER copying innerHTML)
          const priceEl = mainItem.querySelector('.product-block-subscribe-current-price');
          const oldEl = mainItem.querySelector('.product-block-subscribe-old-price');
          const pmap = PRICE_MAP && PRICE_MAP[String(product.id)] && PRICE_MAP[String(product.id)].variants ? PRICE_MAP[String(product.id)].variants : null;
          const vMap = pmap ? pmap[String(v.id)] : null;
          
          // Build display price
          let priceValue = vMap && typeof vMap.price !== 'undefined' && vMap.price !== null ? vMap.price : v.price;
          if (typeof priceValue === 'number' && Number.isInteger(priceValue) && priceValue > 10 && priceValue < 1000000) {
            priceValue = priceValue / 100;
          }
          const displayPrice = formatDisplayPrice(priceValue, qtyMultiplier);
          if (priceEl) priceEl.textContent = displayPrice;
          
          // Update old price
          if (oldEl){
            let compareAtPriceValue = null;
            
            // Get compare_at_price from vMap or variant
            if (vMap && vMap.compare_at_price) {
              compareAtPriceValue = vMap.compare_at_price;
            } else if (v.compare_at_price) {
              compareAtPriceValue = v.compare_at_price;
            }
            
            // Process compare_at_price value
            if (compareAtPriceValue) {
              // If it's a number that looks like cents, convert to currency units
              if (typeof compareAtPriceValue === 'number' && Number.isInteger(compareAtPriceValue) && compareAtPriceValue > 10 && compareAtPriceValue < 1000000) {
                compareAtPriceValue = compareAtPriceValue / 100;
              } else if (typeof compareAtPriceValue === 'string') {
                // Try to parse string value
                const centsValue = formatMoneyCents(compareAtPriceValue);
                compareAtPriceValue = typeof centsValue === 'number' ? centsValue / 100 : parseAmountToNumber(compareAtPriceValue);
              }
              
              // Calculate with quantity multiplier
              const compareAtPriceWithQty = compareAtPriceValue * qtyMultiplier;
              const finalPriceValue = priceValue * qtyMultiplier;
              
              // Check if compare_at_price is greater than price
              if (compareAtPriceWithQty > finalPriceValue) {
                const formattedCompare = formatDisplayPrice(compareAtPriceValue, qtyMultiplier);
                oldEl.textContent = formattedCompare;
                oldEl.style.display = '';
              } else {
                oldEl.style.display = 'none';
              }
            } else {
              oldEl.style.display = 'none';
            }
          }
          
          // Update option text if auto (__AUTO__) - not needed here as it's handled in populateSubscriptions
        }
        
        // Update all options with __AUTO__ text
        if (selectDropdown) {
          planMap.forEach(planKey => {
            const variantInfo = currentVariantData[planKey];
            if (variantInfo) {
              const option = selectDropdown.querySelector(`.product-block-subscribe-select-option[data-value="${planKey}"]`);
              if (option) {
                const optionText = option.textContent.trim();
                const isAuto = !optionText || optionText === '__AUTO__';
                if (isAuto) {
                  const v = variantInfo.variant;
                  const autoText = mfActive ? 'Zapas na 3 miesiące' : (v?.title || '');
                  if (autoText) {
                    option.textContent = autoText;
                  }
                }
              }
            }
          });
          
          // Check if only one variant is available (should be 3-month)
          const availablePlans = Object.keys(currentVariantData);
          if (availablePlans.length === 1 && availablePlans[0] === '3-month') {
            // Hide other options, show only 3-month
            Array.from(selectDropdown.querySelectorAll('.product-block-subscribe-select-option')).forEach(opt => {
              if (opt.dataset.value !== '3-month') {
                opt.style.display = 'none';
              } else {
                opt.style.display = '';
              }
            });
          } else {
            // Show all available options
            Array.from(selectDropdown.querySelectorAll('.product-block-subscribe-select-option')).forEach(opt => {
              const planKey = opt.dataset.value;
              if (currentVariantData[planKey]) {
                opt.style.display = '';
              } else {
                opt.style.display = 'none';
              }
            });
          }
        }
        
        // Set default selection: check for active class first, then recommended, then first available
        let defaultPlan = null;
        
        // Find recommended template (needed later for class assignment)
        const recommendedTemplate = templates.find(t => t.classList.contains('recommended'));
        
        // Priority 1: Check if mainItem has 'active' class AND the plan exists in currentVariantData
        if (mainItem && (mainItem.classList.contains('active') || root.querySelector('.product-block-one-time.selected'))) {
          const activeSubscribe = mainItem.getAttribute('data-subscribe');
          if (activeSubscribe && currentVariantData[activeSubscribe]) {
            defaultPlan = activeSubscribe;
          }
        }
        
        // Priority 2: Check for recommended template
        if (!defaultPlan && recommendedTemplate) {
          const recommendedSubscribe = recommendedTemplate.getAttribute('data-subscribe');
          if (recommendedSubscribe && currentVariantData[recommendedSubscribe]) {
            defaultPlan = recommendedSubscribe;
          }
        }
        
        // Priority 3: Find first available plan (prefer 3-month if it exists, otherwise first available)
        if (!defaultPlan) {
          // First check if 3-month is available (for products with only one variant)
          if (currentVariantData['3-month']) {
            defaultPlan = '3-month';
          } else {
            // Otherwise find first available
            for (const planKey of planMap) {
              if (currentVariantData[planKey]) {
                defaultPlan = planKey;
                break;
              }
            }
          }
        }
        
        // Fallback to 3-month if nothing found
        if (!defaultPlan) {
          defaultPlan = '3-month';
        }
        
        // Update select value and content
        if (selectButton && selectDropdown) {
          const selectedOption = selectDropdown.querySelector(`.product-block-subscribe-select-option[data-value="${defaultPlan}"]`);
          if (selectedOption) {
            const selectText = selectButton.querySelector('.product-block-subscribe-select-text');
            if (selectText) {
              selectText.textContent = selectedOption.textContent;
            }
            // Update native select for form submission
            if (selectNative) {
              selectNative.value = defaultPlan;
            }
            // Update aria attributes
            selectButton.setAttribute('aria-expanded', 'false');
            // Update selected state in dropdown
            Array.from(selectDropdown.querySelectorAll('.product-block-subscribe-select-option')).forEach(opt => {
              opt.removeAttribute('aria-selected');
              if (opt.dataset.value === defaultPlan) {
                opt.setAttribute('aria-selected', 'true');
              }
            });
          }
        }
        
        // Update main item content for default plan
        updateMainItemContent(defaultPlan);
        
        // Update promo display with selected variant (ensure product_id is set)
        const defaultVariantInfo = currentVariantData[defaultPlan];
        if (defaultVariantInfo && defaultVariantInfo.variant) {
          const variantWithProductId = { ...defaultVariantInfo.variant };
          if (!variantWithProductId.product_id && product && product.id) {
            variantWithProductId.product_id = product.id;
          }
          updatePromoDisplay(variantWithProductId);
        }
        
        // Set main item as active/selected and add recommended class if needed
        mainItem.classList.add('selected', 'active');
        if (recommendedTemplate && defaultPlan === recommendedTemplate.getAttribute('data-subscribe')) {
          mainItem.classList.add('recommended');
        } else {
          mainItem.classList.remove('recommended');
        }
        
        // Update mixed flavour visibility after setting default plan
        try { updateMixedFlavourVisibilityForVariant(mainItem); } catch(e) {}
        
        // Default purchase type = ONE-TIME (decision 27.10.2026). Subscription
        // stays selectable; once the shopper picks it (root.dataset.perlaPurchase
        // === 'subscribe') a re-populate keeps their choice.
        const oneTimeBlock = root.querySelector('.product-block-one-time');
        const oneTimeRadio = root.querySelector('input[type="radio"][value="one-time"]');
        const subscribeRadio = root.querySelector('input[type="radio"][value="subscribe"]');
        const keepSubscribe = root.dataset.perlaPurchase === 'subscribe' || !oneTimeBlock || !currentOneTimeVariant;
        if (keepSubscribe) {
          if (oneTimeBlock) oneTimeBlock.classList.remove('selected', 'active');
          if (oneTimeRadio) oneTimeRadio.checked = false;
          if (subscribeRadio) subscribeRadio.checked = true;
        } else {
          mainItem.classList.remove('selected', 'active');
          if (subscribeRadio) subscribeRadio.checked = false;
          oneTimeBlock.classList.add('selected', 'active');
          if (oneTimeRadio) oneTimeRadio.checked = true;
          try { updatePromoDisplay(currentOneTimeVariant); } catch (e) {}
        }
        
        // Wire custom select handlers
        if (selectButton && selectDropdown) {
          // Remove old listeners if exist
          if (selectButton.__perlaClickHandler) {
            selectButton.removeEventListener('click', selectButton.__perlaClickHandler);
          }
          if (selectButton.__perlaKeyHandler) {
            selectButton.removeEventListener('keydown', selectButton.__perlaKeyHandler);
          }
          
          // Function to close dropdown
          const closeDropdown = function() {
            selectDropdown.style.display = 'none';
            selectButton.setAttribute('aria-expanded', 'false');
            document.removeEventListener('click', closeDropdownOnOutsideClick);
          };
          
          // Function to handle outside clicks
          const closeDropdownOnOutsideClick = function(e) {
            if (!selectWrapper.contains(e.target)) {
              closeDropdown();
            }
          };
          
          // Function to handle option selection
          const selectOption = function(selectedPlan) {
            // Get fresh references to mainItem and templates
            const container = root.querySelector('.product-block-subscribe-variants');
            const currentMainItem = container ? container.querySelector('.product-block-subscribe-variant:not(.product-block-subscribe-variant-template)') : null;
            const currentTemplates = container ? Array.from(container.querySelectorAll('.product-block-subscribe-variant-template')) : [];
            
            if (!currentMainItem) return;
            
            // Update main item content using current variant data
            const variantInfo = currentVariantData[selectedPlan];
            if (!variantInfo) return;
            
            const v = variantInfo.variant;
            
            // Update data attributes
            currentMainItem.dataset.variantId = String(v.id);
            currentMainItem.setAttribute('data-subscribe', selectedPlan);
            
            // Extract and add selling_plan
            let sellingPlanId = null;
            if (v.selling_plan_allocations && Array.isArray(v.selling_plan_allocations) && v.selling_plan_allocations.length > 0) {
              const allocation = v.selling_plan_allocations[0];
              if (allocation && allocation.selling_plan_id) {
                sellingPlanId = allocation.selling_plan_id;
              }
            }
            if (sellingPlanId) {
              currentMainItem.dataset.sellingPlan = String(sellingPlanId);
            } else {
              currentMainItem.removeAttribute('data-selling-plan');
            }
            
            // Update content from template if exists
            const template = currentTemplates.find(t => t.getAttribute('data-subscribe') === selectedPlan);
            if (template) {
              const templateBlock = template.querySelector('.product-block-subscribe-variant-block');
              if (templateBlock) {
                // Update per-serving text
                const templatePerServing = templateBlock.querySelector('.product-block-subscribe-per-serving');
                const mainPerServing = currentMainItem.querySelector('.product-block-subscribe-per-serving');
                if (templatePerServing && mainPerServing) {
                  mainPerServing.innerHTML = templatePerServing.innerHTML;
                }
                
                // Update save text - only update p element, preserve img
                const templateSaveText = templateBlock.querySelector('.product-block-subscribe-left-save');
                const mainSaveText = currentMainItem.querySelector('.product-block-subscribe-left-save');
                if (templateSaveText && mainSaveText) {
                  const templateP = templateSaveText.querySelector('p');
                  const mainP = mainSaveText.querySelector('p');
                  if (templateP && mainP) {
                    mainP.innerHTML = templateP.innerHTML;
                  }
                }
              }
              
              // Update delivered text - preserve img, update only text content
              const templateContent = template.querySelector('.product-block-subscribe-variant-content');
              if (templateContent) {
                const templateDelivered = templateContent.querySelector('.product-block-delivered');
                const mainDelivered = currentMainItem.querySelector('.product-block-delivered');
                if (templateDelivered && mainDelivered) {
                  // Get text content from template (excluding img)
                  const templateClone = templateDelivered.cloneNode(true);
                  const templateImg = templateClone.querySelector('img');
                  if (templateImg) {
                    templateImg.remove();
                  }
                  const templateText = templateClone.textContent.trim();
                  
                  // Update main delivered - preserve img, update text
                  const mainImg = mainDelivered.querySelector('img');
                  if (mainImg) {
                    // Remove all text nodes, keep only img
                    const textNodes = [];
                    for (let node of mainDelivered.childNodes) {
                      if (node.nodeType === Node.TEXT_NODE) {
                        textNodes.push(node);
                      }
                    }
                    textNodes.forEach(node => node.remove());
                    
                    // Add text after img
                    const textNode = document.createTextNode(' ' + templateText);
                    mainDelivered.appendChild(textNode);
                  } else {
                    // If no img, just update innerHTML
                    mainDelivered.innerHTML = templateDelivered.innerHTML;
                  }
                }
              }
            }
            
            // Update prices dynamically
            const mfButton = root.querySelector('.product-block-flavour-mf');
            const mfActive = !!(mfButton && mfButton.classList && mfButton.classList.contains('active'));
            let qtyMultiplier = 1;
            if (!mfActive) {
              try {
                const m = selectedPlan.match(/(\d+)/);
                if (m && m[1]) {
                  const q = parseInt(m[1], 10);
                  if (!isNaN(q) && q > 0) qtyMultiplier = q;
                }
              } catch(e){ qtyMultiplier = 1; }
            }
            
            const priceEl = currentMainItem.querySelector('.product-block-subscribe-current-price');
            const oldEl = currentMainItem.querySelector('.product-block-subscribe-old-price');
            const pmap = PRICE_MAP && PRICE_MAP[String(product.id)] && PRICE_MAP[String(product.id)].variants ? PRICE_MAP[String(product.id)].variants : null;
            const vMap = pmap ? pmap[String(v.id)] : null;
            
            // Build display price
            let priceValue = vMap && typeof vMap.price !== 'undefined' && vMap.price !== null ? vMap.price : v.price;
            if (typeof priceValue === 'number' && Number.isInteger(priceValue) && priceValue > 10 && priceValue < 1000000) {
              priceValue = priceValue / 100;
            }
            const displayPrice = formatDisplayPrice(priceValue, qtyMultiplier);
            if (priceEl) priceEl.textContent = displayPrice;
            
            // Update old price
            if (oldEl){
              let compareAtPriceValue = null;
              
              // Get compare_at_price from vMap or variant
              if (vMap && vMap.compare_at_price) {
                compareAtPriceValue = vMap.compare_at_price;
              } else if (v.compare_at_price) {
                compareAtPriceValue = v.compare_at_price;
              }
              
              // Process compare_at_price value
              if (compareAtPriceValue) {
                // If it's a number that looks like cents, convert to currency units
                if (typeof compareAtPriceValue === 'number' && Number.isInteger(compareAtPriceValue) && compareAtPriceValue > 10 && compareAtPriceValue < 1000000) {
                  compareAtPriceValue = compareAtPriceValue / 100;
                } else if (typeof compareAtPriceValue === 'string') {
                  // Try to parse string value
                  const centsValue = formatMoneyCents(compareAtPriceValue);
                  compareAtPriceValue = typeof centsValue === 'number' ? centsValue / 100 : parseAmountToNumber(compareAtPriceValue);
                }
                
                // Calculate with quantity multiplier
                const compareAtPriceWithQty = compareAtPriceValue * qtyMultiplier;
                const finalPriceValue = priceValue * qtyMultiplier;
                
                // Check if compare_at_price is greater than price
                if (compareAtPriceWithQty > finalPriceValue) {
                  const formattedCompare = formatDisplayPrice(compareAtPriceValue, qtyMultiplier);
                  oldEl.textContent = formattedCompare;
                  oldEl.style.display = '';
                } else {
                  oldEl.style.display = 'none';
                }
              } else {
                oldEl.style.display = 'none';
              }
            }
            
            // Update selection state - switch to subscribe variant
            const oneTimeBlock = root.querySelector('.product-block-one-time');
            const subscribeRadio = root.querySelector('input[type="radio"][value="subscribe"]');
            const oneTimeRadio = root.querySelector('input[type="radio"][value="one-time"]');
            
            // Remove selected/active from one-time block
            if (oneTimeBlock) {
              oneTimeBlock.classList.remove('selected', 'active');
            }
            if (oneTimeRadio) {
              oneTimeRadio.checked = false;
            }
            
            // Add selected/active to subscribe variant and check radio
            root.dataset.perlaPurchase = 'subscribe';
            currentMainItem.classList.add('selected', 'active');
            if (subscribeRadio) {
              subscribeRadio.checked = true;
            }
            
            // Update recommended class
            const recommendedTemplate = currentTemplates.find(t => t.classList.contains('recommended'));
            if (recommendedTemplate && selectedPlan === recommendedTemplate.getAttribute('data-subscribe')) {
              currentMainItem.classList.add('recommended');
            } else {
              currentMainItem.classList.remove('recommended');
            }
            
            // Update mixed flavour visibility
            try { updateMixedFlavourVisibilityForVariant(currentMainItem); } catch(e) {}
            
            // Update select button text
            const selectedOptionEl = selectDropdown.querySelector(`.product-block-subscribe-select-option[data-value="${selectedPlan}"]`);
            if (selectedOptionEl) {
              const selectText = selectButton.querySelector('.product-block-subscribe-select-text');
              if (selectText) {
                selectText.textContent = selectedOptionEl.textContent;
              }
              // Update native select
              if (selectNative) {
                selectNative.value = selectedPlan;
              }
              // Update aria attributes
              Array.from(selectDropdown.querySelectorAll('.product-block-subscribe-select-option')).forEach(opt => {
                opt.removeAttribute('aria-selected');
                if (opt.dataset.value === selectedPlan) {
                  opt.setAttribute('aria-selected', 'true');
                }
              });
            }
            
            // Update promo display with selected variant (ensure product_id is set)
            const variantWithProductId = { ...v };
            if (!variantWithProductId.product_id && product && product.id) {
              variantWithProductId.product_id = product.id;
            }
            updatePromoDisplay(variantWithProductId);
            
            // Close dropdown
            closeDropdown();
          };
          
          // Button click handler - toggle dropdown
          const buttonClickHandler = function(e) {
            e.preventDefault();
            e.stopPropagation();
            const isOpen = selectButton.getAttribute('aria-expanded') === 'true';
            if (isOpen) {
              closeDropdown();
            } else {
              selectDropdown.style.display = 'block';
              selectButton.setAttribute('aria-expanded', 'true');
              // Add click outside listener
              setTimeout(() => {
                document.addEventListener('click', closeDropdownOnOutsideClick);
              }, 0);
            }
          };
          
          // Option click handlers
          Array.from(selectDropdown.querySelectorAll('.product-block-subscribe-select-option')).forEach(optionEl => {
            if (optionEl.__perlaOptionHandler) {
              optionEl.removeEventListener('click', optionEl.__perlaOptionHandler);
            }
            const optionClickHandler = function(e) {
              e.preventDefault();
              e.stopPropagation();
              const planValue = optionEl.dataset.value;
              if (planValue && currentVariantData[planValue]) {
                selectOption(planValue);
              }
            };
            optionEl.__perlaOptionHandler = optionClickHandler;
            optionEl.addEventListener('click', optionClickHandler);
            
            // Keyboard support
            optionEl.addEventListener('keydown', function(e) {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                const planValue = optionEl.dataset.value;
                if (planValue && currentVariantData[planValue]) {
                  selectOption(planValue);
                }
              }
            });
          });
          
          // Button keyboard handler
          const buttonKeyHandler = function(e) {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
              e.preventDefault();
              if (selectButton.getAttribute('aria-expanded') !== 'true') {
                selectDropdown.style.display = 'block';
                selectButton.setAttribute('aria-expanded', 'true');
                setTimeout(() => {
                  document.addEventListener('click', closeDropdownOnOutsideClick);
                }, 0);
              }
            } else if (e.key === 'Escape') {
              e.preventDefault();
              closeDropdown();
            }
          };
          
          selectButton.__perlaClickHandler = buttonClickHandler;
          selectButton.__perlaKeyHandler = buttonKeyHandler;
          selectButton.addEventListener('click', buttonClickHandler);
          selectButton.addEventListener('keydown', buttonKeyHandler);
        }
        const oneBtn = root.querySelector('.add-to-card-one-time-button');
        const oneBtnPrice = oneBtn ? document.querySelector('.add-to-card-one-time-button-price') : null;
        if (oneBtn){
          if (oneTime){
            oneBtn.dataset.variantId = String(oneTime.id);
            oneBtn.disabled = false;
            // Update only price element, not the whole button text
            if (oneBtnPrice) {
              try {
                const pmap = PRICE_MAP && PRICE_MAP[String(product.id)] && PRICE_MAP[String(product.id)].variants ? PRICE_MAP[String(product.id)].variants : null;
                const vMap = pmap ? pmap[String(oneTime.id)] : null;
                let priceValue = vMap && vMap.price ? vMap.price : oneTime.price;
                // If price is a number that looks like cents (integer > 10 and < 1000000), divide by 100
                if (typeof priceValue === 'number' && Number.isInteger(priceValue) && priceValue > 10 && priceValue < 1000000) {
                  priceValue = priceValue / 100;
                }
                const formattedPrice = formatDisplayPrice(priceValue, 1);
                oneBtnPrice.textContent = formattedPrice;
              } catch(e) {}
            }
          } else {
            const fallback = (product.variants && product.variants[0]) ? product.variants[0] : null;
            if (fallback){
              oneBtn.dataset.variantId = String(fallback.id);
              oneBtn.disabled = false;
              // Update only price element with fallback price
              if (oneBtnPrice) {
                try {
                  let fallbackPrice = fallback.price;
                  // If price is a number that looks like cents (integer > 10 and < 1000000), divide by 100
                  if (typeof fallbackPrice === 'number' && Number.isInteger(fallbackPrice) && fallbackPrice > 10 && fallbackPrice < 1000000) {
                    fallbackPrice = fallbackPrice / 100;
                  }
                  const formattedPrice = formatDisplayPrice(fallbackPrice, 1);
                  oneBtnPrice.textContent = formattedPrice;
                } catch(e) {}
              }
            } else {
              oneBtn.removeAttribute('data-variant-id');
              oneBtn.disabled = true;
              if (oneBtnPrice) {
                oneBtnPrice.textContent = '';
              }
            }
          }
        }
      }
      function wirePaymentButtons(){
        const payBtn = root.querySelector('.add-to-card-button');
        const oneBtn = root.querySelector('.add-to-card-one-time-button');
        const base = (window && window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
        let isAddingToCart = false; // Flag to prevent multiple simultaneous calls
        
        // Function to show/hide loader on button
        function setButtonLoading(button, isLoading) {
          if (!button) return;
          if (isLoading) {
            button.disabled = true;
            const originalText = button.textContent || button.innerHTML;
            button.dataset.originalText = originalText;
            button.innerHTML = '<svg class="spinner" width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle class="spinner-path" fill="none" stroke-width="2" stroke-linecap="round" cx="10" cy="10" r="9"></circle></svg>';
            button.classList.add('loading');
          } else {
            button.disabled = false;
            if (button.dataset.originalText) {
              button.innerHTML = button.dataset.originalText;
              delete button.dataset.originalText;
            }
            button.classList.remove('loading');
          }
        }
        
        async function clearThenAddAndCheckout(variantId, quantity, sellingPlanId, button){
          if (!variantId) return;
          if (isAddingToCart) return; // Prevent multiple simultaneous calls
          isAddingToCart = true;
          
          // Show loader on button
          setButtonLoading(button, true);
          
          const qty = Math.max(1, Number(quantity || 1));
          try {
            await fetch(base.replace(/\/$/, '/') + 'cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin' });
          } catch(e) {
            isAddingToCart = false;
            setButtonLoading(button, false);
            return;
          }
          try {
            // Add main product and additional product in one request
            const cartItem = { id: Number(variantId), quantity: qty };
            if (sellingPlanId && sellingPlanId !== '' && sellingPlanId !== 'null' && sellingPlanId !== 'undefined') {
              const planId = Number(sellingPlanId);
              if (!isNaN(planId) && planId > 0) {
                cartItem.selling_plan = planId;
              }
            }
            
            // Add additional product variant (56638408950133) - only once
            const additionalVariantId = 56638408950133;
            const cartItems = [
              cartItem,
              { id: additionalVariantId, quantity: 1 }
            ];
            
            await fetch(base.replace(/\/$/, '/') + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ items: cartItems })
            });
          } catch(e) {
            isAddingToCart = false;
            setButtonLoading(button, false);
            return;
          }
          // Set cart attribute to enable tagging the order as "sales page" upon creation
          try {
            await fetch(base.replace(/\/$/, '/') + 'cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ attributes: { 
                  tags: 'sales_page',
                  order_tag: 'sales_page',
                  source: 'sales_page' } })
            });
          } catch(e) {}
          isAddingToCart = false;
          // Don't hide loader here as we're redirecting
          window.location.href = base.replace(/\/$/, '/') + 'checkout';
        }
        // Wire selection handlers for subscribe variant and one-time
        const subscribeVariant = root.querySelector('.product-block-subscribe-variant:not(.product-block-subscribe-variant-template)');
        const oneTimeBlock = root.querySelector('.product-block-one-time');
        
        // Find radio buttons
        const subscribeRadio = root.querySelector('input[type="radio"][value="subscribe"]');
        const oneTimeRadio = root.querySelector('input[type="radio"][value="one-time"]');
        
        // Function to update selection state
        function updateSelection(selectSubscribe) {
          root.dataset.perlaPurchase = selectSubscribe ? 'subscribe' : 'one-time';
          if (selectSubscribe) {
            // Select subscribe variant
            if (subscribeVariant) {
              subscribeVariant.classList.add('selected', 'active');
            }
            if (subscribeRadio) {
              subscribeRadio.checked = true;
            }
            // Deselect one-time
            if (oneTimeBlock) {
              oneTimeBlock.classList.remove('selected', 'active');
            }
            if (oneTimeRadio) {
              oneTimeRadio.checked = false;
            }
            // Update promo display with selected subscribe variant
            const selectedSubscribeVariant = root.querySelector('.product-block-subscribe-variant.selected') || root.querySelector('.product-block-subscribe-variant:not(.product-block-subscribe-variant-template)');
            if (selectedSubscribeVariant && selectedSubscribeVariant.dataset.variantId) {
              // Find variant in currentVariantData
              const subscribePlan = selectedSubscribeVariant.getAttribute('data-subscribe');
              if (subscribePlan && currentVariantData[subscribePlan]) {
                const variantInfo = currentVariantData[subscribePlan];
                if (variantInfo && variantInfo.variant) {
                  const variantWithProductId = { ...variantInfo.variant };
                  // Ensure product_id is set
                  if (!variantWithProductId.product_id && currentProduct && currentProduct.id) {
                    variantWithProductId.product_id = currentProduct.id;
                  }
                  updatePromoDisplay(variantWithProductId);
                }
              }
            }
          } else {
            // Select one-time
            if (oneTimeBlock) {
              oneTimeBlock.classList.add('selected', 'active');
            }
            if (oneTimeRadio) {
              oneTimeRadio.checked = true;
            }
            // Deselect subscribe variant
            if (subscribeVariant) {
              subscribeVariant.classList.remove('selected', 'active');
            }
            if (subscribeRadio) {
              subscribeRadio.checked = false;
            }
            // Update promo display with one-time variant
            if (currentOneTimeVariant) {
              updatePromoDisplay(currentOneTimeVariant);
            }
          }
        }
        
        // Handle subscribe variant click
        if (subscribeVariant && !subscribeVariant.__perlaSelectionBound) {
          subscribeVariant.__perlaSelectionBound = true;
          subscribeVariant.addEventListener('click', function(e) {
            // Don't trigger on select element clicks or radio button clicks
            if (e.target.closest('.product-block-subscribe-select-wrapper') || e.target.closest('.product-block-subscribe-select') || e.target.type === 'radio') return;
            
            e.preventDefault();
            e.stopPropagation();
            
            updateSelection(true);
          });
        }
        
        // Handle one-time block click
        if (oneTimeBlock && !oneTimeBlock.__perlaSelectionBound) {
          oneTimeBlock.__perlaSelectionBound = true;
          oneTimeBlock.addEventListener('click', function(e) {
            // Don't trigger on button clicks or radio button clicks
            if (e.target.closest('.add-to-card-one-time-button') || e.target.type === 'radio') return;
            
            e.preventDefault();
            e.stopPropagation();
            
            updateSelection(false);
          });
        }
        
        // Handle radio button changes
        if (subscribeRadio && !subscribeRadio.__perlaRadioBound) {
          subscribeRadio.__perlaRadioBound = true;
          subscribeRadio.addEventListener('change', function() {
            if (this.checked) {
              updateSelection(true);
            }
          });
        }
        
        if (oneTimeRadio && !oneTimeRadio.__perlaRadioBound) {
          oneTimeRadio.__perlaRadioBound = true;
          oneTimeRadio.addEventListener('change', function() {
            if (this.checked) {
              updateSelection(false);
            }
          });
        }
        
        // Main checkout button - checks which option is selected
        if (payBtn && !payBtn.__perlaBound){
          payBtn.__perlaBound = true;
          payBtn.addEventListener('click', function(e){
            e.preventDefault();
            
            // Check if one-time is selected
            const oneTimeSelected = oneTimeBlock && oneTimeBlock.classList.contains('selected');
            
            if (oneTimeSelected) {
              // One-time purchase
              const vid = oneBtn && oneBtn.dataset ? oneBtn.dataset.variantId : null;
              if (vid) {
                clearThenAddAndCheckout(vid, 1, null, payBtn);
              }
            } else {
              // Subscribe variant (default)
              const sel = root.querySelector('.product-block-subscribe-variant.selected') || root.querySelector('.product-block-subscribe-variant:not(.product-block-subscribe-variant-template)');
              const vid = sel && sel.dataset ? sel.dataset.variantId : null;
              // Extract selling_plan from dataset or attribute (similar to variantId)
              const sellingPlanId = sel && sel.dataset ? sel.dataset.sellingPlan : null;
              // Quantity: derive from data-subscribe (1/2/3), except when Mixed Flavours is active -> always 1
              let qty = 1;
              try {
                const isMfActive = !!root.querySelector('.product-block-flavour-mf.active');
                if (!isMfActive && sel) {
                  const ds = (sel.getAttribute('data-subscribe') || '').trim();
                  const match = ds.match(/(\d+)/);
                  if (match && match[1]) {
                    const parsed = parseInt(match[1], 10);
                    if (!isNaN(parsed) && parsed > 0) qty = parsed;
                  }
                }
              } catch(e) { qty = 1; }
              clearThenAddAndCheckout(vid, qty, sellingPlanId, payBtn);
            }
          });
        }
        
        // One-time button now only selects the option, doesn't go to checkout
        if (oneBtn && !oneBtn.__perlaBound){
          oneBtn.__perlaBound = true;
          oneBtn.addEventListener('click', function(e){
            e.preventDefault();
            e.stopPropagation();
            
            updateSelection(false);
          });
        }
      }
      async function onClickFlavour(ev){
        const btn = ev.currentTarget; if(!btn) return;
        const productId = (btn.getAttribute('product-id') || '').trim();
        const variantId = (btn.getAttribute('variant-id') || '').trim();
        if (!productId && !variantId) return;
        // First get basic product to obtain handle
        const basicProduct = await fetchProductByIdOrVariantAttrs({ productId, variantId });
        if (!basicProduct) return;
        // Get handle from basic product
        const handle = basicProduct.handle;
        // Get full product with selling_plan data using handle
        let fullProduct = null;
        if (handle) {
          fullProduct = await getFullProductByHandle(handle);
        }
        // Use images from basic product (they have correct structure), but selling_plan from full product
        const images = mapProductToImages(basicProduct);
        if (images && images.length){ swapCarousel(images); }
        // Use full product for subscriptions (has selling_plan), fallback to basic if needed
        const productForSubscriptions = fullProduct || basicProduct;
        if (productForSubscriptions){
          populateSubscriptions(productForSubscriptions);
          // Update promo display after subscriptions are populated
          // Get the first variant from the default plan
          const mainItem = root.querySelector('.product-block-subscribe-variant:not(.product-block-subscribe-variant-template)');
          if (mainItem && mainItem.dataset.variantId && mainItem.classList.contains('active')) {
            const variantId = mainItem.dataset.variantId;
            const variant = productForSubscriptions.variants?.find(v => String(v.id) === String(variantId));
            if (variant) {
              // Add product_id to variant for price map lookup
              variant.product_id = productForSubscriptions.id;
              updatePromoDisplay(variant);
            }
          }
        }
      }
      function ready(){
        const btns = root.querySelectorAll('.product-block-flavours[product-id], .product-block-flavours[variant-id]');
        // Ensure mixed-flavour button starts hidden
        initMixedFlavourVisibility();
        // Existing selection logic
        btns.forEach(btn => btn.addEventListener('click', (ev) => {
          try { ev.preventDefault(); ev.stopPropagation(); } catch(e){}
          btns.forEach(b => { try { b.classList.remove('selected'); b.classList.remove('active'); b.setAttribute('aria-pressed','false'); } catch(e){} });
          try { ev.currentTarget.classList.add('active'); ev.currentTarget.setAttribute('aria-pressed','true'); } catch(e){}
          onClickFlavour(ev);
        }));
        const first = root.querySelector('.product-block-flavours[product-id], .product-block-flavours[variant-id]');
        if (first) { try { first.setAttribute('aria-pressed','true'); first.classList.add('active'); first.click(); } catch(e){} }
      }
      ready();
      wirePaymentButtons();
      wirePromoCopyButton();
    }
    function bootAll(){
      const sections = document.querySelectorAll('section.product-block.container[data-section-id], [data-section-id].product-block.container');
      sections.forEach(initSection);
    }
    if (document.readyState !== 'loading') { bootAll(); } else { document.addEventListener('DOMContentLoaded', bootAll); }
    document.addEventListener('shopify:section:load', (e) => {
      const root = e.target && (e.target.matches('section.product-block.container') ? e.target : e.target.querySelector('section.product-block.container'));
      if (root) initSection(root);
    });
  })();
  
  
  (function(){
    function expandVariant(variant){
      const content = variant.querySelector('.product-block-subscribe-variant-content');
      if (!content) return;
      const root = variant.closest('section.product-block.container') || document;
      root.querySelectorAll('.product-block-subscribe-variant').forEach(v => {
        if (v !== variant) {
          v.classList.remove('active');
        }
      });
      variant.classList.add('active');
    }
    function collapseVariant(variant){
      variant.classList.remove('active');
    }
    function wireSubscriptionVariantTogglesIn(root){
      // With new structure, we only have one main variant block (not templates)
      const mainVariant = root.querySelector('.product-block-subscribe-variant:not(.product-block-subscribe-variant-template)');
      if (!mainVariant) return;
      
      // Expand variant content if active
      if (mainVariant.classList.contains('active')) {
        expandVariant(mainVariant);
      }
      
    }
    function wireReviewerReadMoreIn(root){
      // Prepare wraps (idempotent)
      root.querySelectorAll('.product-block-reviewer-description-wrap').forEach(wrap => {
        const nextEl = wrap.querySelector('.product-block-reviewer-description-next');
        const baseEl = wrap.querySelector('.product-block-reviewer-description');
        if (!nextEl) return;
        nextEl.style.overflow = 'hidden';
        nextEl.style.height = nextEl.style.height || '0px';
        nextEl.style.opacity = nextEl.style.opacity || '0';
        if (!nextEl.style.transition) {
          nextEl.style.transition = 'height 0.3s ease, opacity 0.3s ease';
        }
        if (baseEl && !baseEl.dataset.baseText) {
          const original = (baseEl.textContent || '').trimEnd();
          const stripped = original.replace(/\s*(\u2026|\.{3})\s*$/,'');
          baseEl.dataset.baseText = stripped;
        }
      });
      // Delegate click binding once per section root
      if (!root.__reviewerDelegatedBound) {
        root.addEventListener('click', function(e){
          const btn = e.target && e.target.closest('.product-block-reviewer-description-button');
          if (!btn || !root.contains(btn)) return;
          e.preventDefault();
          const wrap = btn.closest('.product-block-reviewer-description-wrap');
          if (!wrap) return;
          const nextEl = wrap.querySelector('.product-block-reviewer-description-next');
          const baseEl = wrap.querySelector('.product-block-reviewer-description');
          if (!nextEl) return;
          const isOpen = wrap.classList.toggle('is-open');
          if (isOpen) {
            if (baseEl && baseEl.dataset.baseText) {
              baseEl.textContent = baseEl.dataset.baseText;
            }
            nextEl.style.height = nextEl.scrollHeight + 'px';
            nextEl.style.opacity = '1';
            btn.setAttribute('aria-expanded', 'true');
            const onEnd = (ev) => {
              if (ev.propertyName === 'height') {
                nextEl.style.height = 'auto';
                nextEl.removeEventListener('transitionend', onEnd);
              }
            };
            nextEl.addEventListener('transitionend', onEnd);
          } else {
            if (baseEl && baseEl.dataset.baseText) {
              baseEl.textContent = baseEl.dataset.baseText + '...';
            }
            if (nextEl.style.height === 'auto') {
              nextEl.style.height = nextEl.scrollHeight + 'px';
              void nextEl.offsetHeight;
            }
            nextEl.style.height = '0px';
            nextEl.style.opacity = '0';
            btn.setAttribute('aria-expanded', 'false');
          }
        });
        Object.defineProperty(root, '__reviewerDelegatedBound', { value: true, enumerable: false, configurable: false });
      }
    }
    function wireReviewerImageModalIn(root){
      if (!root) return;
      // Create singleton modal for the page (shared across sections)
      let modal = document.querySelector('.product-block-reviewer-modal');
      if (!modal) {
        modal = document.createElement('div');
        modal.className = 'product-block-reviewer-modal';
        modal.style.position = 'fixed';
        modal.style.inset = '0';
        modal.style.zIndex = '9999';
        modal.style.background = 'rgba(0,0,0,0.7)';
        modal.style.display = 'none';
        modal.style.alignItems = 'center';
        modal.style.justifyContent = 'center';
        modal.style.padding = '20px';
        modal.style.cursor = 'zoom-out';
        modal.style.boxSizing = 'border-box';
        // Inner wrapper to position close button relative to the image
        const inner = document.createElement('div');
        inner.className = 'product-block-reviewer-modal-inner';
        inner.style.position = 'relative';
        inner.style.display = 'inline-block';
        modal.appendChild(inner);
        // Enlarged image
        const img = document.createElement('img');
        img.className = 'product-block-reviewer-modal-image';
        img.style.maxWidth = '90vw';
        img.style.maxHeight = '90vh';
        img.style.width = 'auto';
        img.style.height = 'auto';
        img.style.boxShadow = '0 8px 30px rgba(0,0,0,0.5)';
        img.style.borderRadius = '8px';
        img.alt = '';
        inner.appendChild(img);
        // Close button (top-right of image)
        const closeBtn = document.createElement('button');
        closeBtn.className = 'product-block-reviewer-modal-close';
        closeBtn.type = 'button';
        closeBtn.setAttribute('aria-label', 'Close');
        closeBtn.style.position = 'absolute';
        closeBtn.style.top = '8px';
        closeBtn.style.right = '8px';
        closeBtn.style.border = 'none';
        closeBtn.style.background = 'transparent';
        closeBtn.style.padding = '6px';
        closeBtn.style.margin = '0';
        closeBtn.style.cursor = 'pointer';
        closeBtn.style.lineHeight = '0';
        closeBtn.style.zIndex = '10001';
        const closeImg = document.createElement('img');
        closeImg.src = 'https://cdn.shopify.com/s/files/1/0928/3882/2261/files/black_cross.webp?v=1765206704';
        closeImg.alt = 'Close';
        closeImg.style.width = '24px';
        closeImg.style.height = '24px';
        closeImg.style.display = 'block';
        closeBtn.appendChild(closeImg);
        inner.appendChild(closeBtn);
        document.body.appendChild(modal);
        // Close handlers
        modal.addEventListener('click', (e) => {
          // Close when clicking outside the image
          if (e.target === modal) {
            modal.style.display = 'none';
            const mimg = modal.querySelector('img.product-block-reviewer-modal-image');
            if (mimg) { mimg.src = ''; mimg.alt = ''; }
          }
        });
        closeBtn.addEventListener('click', (e) => {
          try { e.preventDefault(); e.stopPropagation(); } catch(_) {}
          modal.style.display = 'none';
          const mimg = modal.querySelector('img.product-block-reviewer-modal-image');
          if (mimg) { mimg.src = ''; mimg.alt = ''; }
        });
        // Escape to close
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && modal.style.display !== 'none') {
            modal.style.display = 'none';
            const mimg = modal.querySelector('img.product-block-reviewer-modal-image');
            if (mimg) { mimg.src = ''; mimg.alt = ''; }
          }
        });
      }
      // Delegate clicks within this root
      if (!root.__reviewerImageModalBound) {
        root.addEventListener('click', function(e){
          const wrap = e.target && e.target.closest && e.target.closest('.product-block-reviewer-image-wrap');
          if (!wrap || !root.contains(wrap)) return;
          e.preventDefault();
          const img = wrap.querySelector('img');
          if (!img) return;
          const src = img.currentSrc || img.src;
          if (!src) return;
          const modalImg = document.querySelector('.product-block-reviewer-modal img.product-block-reviewer-modal-image');
          if (!modalImg) return;
          modalImg.src = src;
          modalImg.alt = img.alt || '';
          const m = document.querySelector('.product-block-reviewer-modal');
          if (m) {
            m.style.display = 'flex';
          }
        });
        Object.defineProperty(root, '__reviewerImageModalBound', { value: true, enumerable: false, configurable: false });
      }
    }
    function bootUIAll(){
      const sections = document.querySelectorAll('section.product-block.container[data-section-id], [data-section-id].product-block.container');
      sections.forEach((root) => {
        wireSubscriptionVariantTogglesIn(root);
        wireReviewerReadMoreIn(root);
        wireReviewerImageModalIn(root);
      });
    }
    if (document.readyState !== 'loading') { bootUIAll(); } else { document.addEventListener('DOMContentLoaded', bootUIAll); }
    document.addEventListener('shopify:section:load', (e) => {
      const root = e.target && (e.target.matches('section.product-block.container') ? e.target : e.target.querySelector('section.product-block.container'));
      if (root) {
        wireSubscriptionVariantTogglesIn(root);
        wireReviewerReadMoreIn(root);
        wireReviewerImageModalIn(root);
      }
    });
  })();